import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcProgressComponent} from './ac-progress.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule
    ],
    declarations: [
        AcProgressComponent,
    ],
    entryComponents: [
        AcProgressComponent,
    ],
    exports: [
        AcProgressComponent,
    ]
})
export class AcProgressModule {
}
